<template>
  <div class="sysLog">
    <a-card>
      <div class="search" @keyup.enter="getPageList(1)">
        <a-form-model layout="inline" :model="searchForm">
          <a-form-model-item label="时间范围">
            <a-date-picker
              v-model="searchForm.startTime"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              placeholder="开始时间"
              style="width: 180px"
            />
            <a-date-picker
              v-model="searchForm.endTime"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              placeholder="结束时间"
              style="width: 180px; margin-left: 10px"
            />
          </a-form-model-item>
          <a-form-model-item label="应用名称">
            <a-input
              v-model="searchForm.applicationName"
              placeholder="请输入应用名称"
              style="width: 150px"
            />
          </a-form-model-item>
          <a-form-model-item>
            <a-button @click="getPageList(1)" type="primary" html-type="button">查询</a-button>
            <a-button @click="searchReset" style="margin-left: 10px">重置</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
      <div style="overflow: auto; margin-top: 15px">
        <a-table
          style="min-width: 900px"
          :columns="columns"
          :pagination="tableRelevant.tablePagination"
          :loading="tableRelevant.tableLoading"
          :locale="tableRelevant.locale"
          :dataSource="tableRelevant.tableDataSource"
          :rowKey="(record) => record.id"
        >
          <div slot="exception" slot-scope="text">
            <a-button type="link" @click="showException(text)" v-if="text">查看</a-button>
            <span v-else>-</span>
          </div>
        </a-table>
      </div>
    </a-card>

    <!-- 异常详情弹窗 -->
    <a-modal
      v-model="exceptionDetail.visible"
      title="异常详情"
      width="800px"
      :footer="null"
    >
      <a-textarea
        v-if="exceptionDetail.record?.exception"
        :value="formatJson(exceptionDetail.record.exception)"
        :rows="20"
        readonly
      />
      <span v-else>-</span>
    </a-modal>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import { SysLog } from '@/utils/http'
import moment from 'moment'

export default {
  name: 'SysLogException',
  data() {
    return {
      searchForm: {
        startTime: moment().subtract(1, 'months').format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        type: 1, // 异常日志
        pageIndex: 1,
        pageSize: 10,
        applicationName: undefined,
      },
      columns: [
        { title: '日期', dataIndex: 'date', width: 180 },
        { title: '消息', dataIndex: 'message', ellipsis: true },
        { title: '应用程序', dataIndex: 'applicationName', width: 150 },
        { title: 'URL', dataIndex: 'url', ellipsis: true, width: 200 },
        { title: '请求方式', dataIndex: 'requestMethod', width: 100 },
        { title: '参数', dataIndex: 'parameter', ellipsis: true },
        { title: '异常', scopedSlots: { customRender: 'exception' }, width: 100, align: 'center' },
      ],
      tableRelevant: tableRelevant.call(this, this.getPageList),
      exceptionDetail: {
        visible: false,
        record: null,
      },
    }
  },
  mounted() {
    this.getPageList()
  },
  methods: {
    formatDate(date, format = 'YYYY-MM-DD HH:mm:ss') {
      return moment(date).format(format)
    },
    formatJson(jsonStr) {
      if (!jsonStr) return ''
      try {
        const parsed = typeof jsonStr === 'string' ? JSON.parse(jsonStr) : jsonStr
        return JSON.stringify(parsed, null, 2)
      } catch (e) {
        return jsonStr
      }
    },
    getPageList(pageIndex) {
      const params = {
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        startTime: this.searchForm.startTime ? this.formatDate(this.searchForm.startTime, 'YYYY-MM-DD HH:mm:ss') : undefined,
        endTime: this.searchForm.endTime ? this.formatDate(this.searchForm.endTime, 'YYYY-MM-DD HH:mm:ss') : undefined,
        type: this.searchForm.type,
        applicationName: this.searchForm.applicationName,
      }
      this.tableRelevant.tableLoading = true
      SysLog.pageList(params).then((res) => {
        const { data } = res
        this.tableRelevant.tableDataSource = data.items
        this.tableRelevant.tablePagination.total = data.totalCount
        this.tableRelevant.tablePagination.current = data.pageIndex
      }).catch((err) => {
        console.error('获取日志列表失败:', err)
      }).finally(() => {
        this.tableRelevant.tableLoading = false
      })
    },
    searchReset() {
      this.searchForm.startTime = moment().subtract(1, 'months').format('YYYY-MM-DD HH:mm:ss')
      this.searchForm.endTime = moment().format('YYYY-MM-DD HH:mm:ss')
      this.searchForm.applicationName = undefined
      this.searchForm.pageIndex = 1
      this.searchForm.pageSize = 10
      this.getPageList()
    },
    showException(record) {
      this.exceptionDetail.record = record
      this.exceptionDetail.visible = true
    },
  },
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 15px;
}
</style>
